module.exports = "https://assets.meiaentrada.org.br/static/media/logo-meia-entrada.1880ce37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-meia-entrada.svg
// module id = 228
// module chunks = 0